import { ActionUser } from "@/modules/profile/components/ModalUser";

export enum ManagementType {
  GROUP = "group",
  AGENCY = "agency",
  TEAM = "team",
  USER = "user",
}

export interface OrganizationNode {
  id: string;
  parentId?: string;
  name: string;
  type: ManagementType;
  role?: string;
  sector?: string[];
  isDisabled?: boolean;
  customer?: {
    id: string;
    offerTypeId: string;
    invoiceFrequencyEdl: string;
    invoiceFrequencyErp: string;
  };
  actions?: {
    text: string | React.ReactNode;
    icon?: React.ReactNode;
    onClick?: () => void;
  }[];
  children?: OrganizationNode[];
}

export interface EntityContext {
  type: ManagementType;
  name: string;
}

export interface Member {
  id: string;
  firstname: string;
  lastname: string;
  email: string;
}

export interface UserManagementModalProps {
  actionType: ActionUser;
  teamId: string;
  teamLabel?: string;
  userId?: string;
  userData?: Member;
}

export interface BanManagementModalProps {
  id: string;
  data: any;
}

export interface RemoveEntityModalProps {
  id: string;
  teamId?: string;
  userType: ManagementType;
  actionType: ActionUser;
  label: string;
}
